import { FirebaseReducer, isLoaded, isEmpty } from "react-redux-firebase"

export const getStartPayloadOf = (typeBeginning: string, payload = true) => {
  return {
    type: typeBeginning + "_START",
    payload: payload,
  }
}

export const getFailurePayloadOf = (typeBeginning: string, payload = null) => {
  return {
    type: typeBeginning + "_ERROR",
    payload: payload,
  }
}

export const getSuccessPayloadOf = (typeBeginning: string, payload: any = null) => {
  return {
    type: typeBeginning + "_SUCCESS",
    payload: payload,
  }
}

export const getSetVisibilityOfModalFormPayloadOf = (typeBeginning: string, payload = null) => {
  return {
    type: typeBeginning + "_SET_VISIBILITY_OF_MODAL_FORM",
    payload: payload,
  }
}

export const getStartTypeOf = (typeBeginning: string) => {
  return typeBeginning + "_START"
}

export const getFailureTypeOf = (typeBeginning: string) => {
  return typeBeginning + "_ERROR"
}

export const getSuccessTypeOf = (typeBeginning: string) => {
  return typeBeginning + "_SUCCESS"
}

export const getSetVisibilityOfModalFormTypeOf = (typeBeginning: string) => {
  return typeBeginning + "_SET_VISIBILITY_OF_MODAL_FORM"
}

export const isLoggedIn = (auth: FirebaseReducer.AuthState): boolean => isLoaded(auth) && !isEmpty(auth);